import { Box, Button, ButtonGroup, DangerButton, Heading2, Modal, Text } from "@nulogy/components";
import Form from "components/controls/Form";
import DatePicker from "components/controls/NDSDatePicker";
import Select from "components/controls/Select";
import React from "react";
import styled from "styled-components";

const PresetSelect = styled(Select)`
  z-index: 5;
`;

export default function ResetSiteView({ onReset, canReset, isResetSiteOpen, setResetSiteOpen }) {
  const dataPresets = [
    { label: "Default", value: "default" },
    { label: "Coman - Cosmetics", value: "cm_cosmetics" },
    { label: "Coman - Food & bev", value: "cm_food_and_bev" },
    { label: "Coman - Household", value: "cm_household" },
    { label: "Coman - Personal care", value: "cm_personal_care" },
    { label: "Copack - Cosmetics", value: "cp_cosmetics" },
    { label: "Copack - Food & bev", value: "cp_food_and_bev" },
    { label: "Copack - Household", value: "cp_household" },
    { label: "Copack - Personal care", value: "cp_personal_care" },
  ];

  const relativeDate = new Date();
  relativeDate.setHours(0, 0, 0, 0);
  const initialValues = { preset: "default", relativeDate };

  const resetButton = (
    <ButtonGroup>
      <DangerButton className="spec-reset-button" form="resetSite" mr="x1" type="submit">
        Reset
      </DangerButton>
    </ButtonGroup>
  );

  if (!canReset) return null;

  return (
    <>
      <Heading2>Danger zone</Heading2>
      <Button
        mb="x1"
        onClick={() => {
          setResetSiteOpen(true);
        }}
      >
        Reset site
      </Button>
      <Modal
        ariaHideApp={false}
        footerContent={resetButton}
        isOpen={isResetSiteOpen}
        onRequestClose={() => {
          setResetSiteOpen(false);
        }}
        title="Reset site"
      >
        <Text style={{ color: "red", marginBottom: "8px" }}>
          Do you want to delete existing data and create sample data?
        </Text>
        <Form id="resetSite" initialValues={initialValues} onSave={onReset}>
          <Box marginTop="x2">
            <Text fontWeight="bold" marginBottom="x1">
              Please select the data set to reset to:
            </Text>
            <PresetSelect className="spec-preset-select" field="preset" menuPosition="fixed" options={dataPresets} />
          </Box>
          <Box marginTop="x2">
            <Text fontWeight="bold" marginBottom="x1">
              Relative date
            </Text>
            <span className="customDatePicker">
              <DatePicker className="spec-relative-date" dateFormat="MMM d, yyyy" field="relativeDate" />
            </span>
          </Box>
        </Form>
      </Modal>
    </>
  );
}
